export default 'products';

export * as actions from './actions';
export * as getters from './getters';
export { default as mutations } from './mutations';
export { default as state } from './state';
